export default {
  // 页面标题和导航
  'pages.net-fee.title': '网费',
  'pages.net-fee.subtitle': '管理小区网费账单的生成、缴费和查询',
  'pages.net-fee.currentSelection': '当前选择：',
  'pages.net-fee.batchGenerate': '批量生成',
  'pages.net-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.net-fee.tabOther': '其他',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.netFee': '网费',

  // 批量生成相关
  'pages.net-fee.batchGenerate.modalTitle': '批量生成网费账单',
  'pages.net-fee.batchGenerate.confirmTitle': '确认批量生成',
  'pages.net-fee.batchGenerate.confirmMessage': '确定要批量生成 {period} 的网费账单吗？',
  'pages.net-fee.batchGenerate.selectPeriod': '选择账期：',
  'pages.net-fee.batchGenerate.selectPeriodPlaceholder': '请选择账期',
  'pages.net-fee.batchGenerate.confirmGenerate': '确认生成',
  'pages.net-fee.batchGenerate.cancel': '取消',
  'pages.net-fee.batchGenerate.tips': '💡 提示：批量生成将为所有未生成账单的房屋创建指定账期的网费账单',
  'pages.net-fee.batchGenerate.tips2': '已存在的账单将不会重复生成',
  'pages.net-fee.batchGenerate.success': '成功生成 {count} 条账单',
  'pages.net-fee.batchGenerate.failure': '批量生成失败',
  'pages.net-fee.batchGenerate.selectPeriodFirst': '请选择账期',

  // 表格相关
  'pages.net-fee.table.title': '网费账单列表',
  'pages.net-fee.table.houseInfo': '房屋信息',
  'pages.net-fee.table.period': '账期',
  'pages.net-fee.table.billNo': '账单编号',
  'pages.net-fee.table.finalAmount': '最终应付金额',
  'pages.net-fee.table.approvalStatus': '审核状态',
  'pages.net-fee.table.paymentStatus': '缴费状态',
  'pages.net-fee.table.paymentTime': '缴费时间',
  'pages.net-fee.table.dueDate': '到期日期',
  'pages.net-fee.table.action': '操作',

  // 操作按钮
  'pages.net-fee.action.view': '查看',
  'pages.net-fee.action.edit': '编辑',
  'pages.net-fee.action.delete': '删除',
  'pages.net-fee.action.create': '新建账单',
  'pages.net-fee.action.submitAudit': '提交审核',
  'pages.net-fee.action.batchDelete': '批量删除',
  'pages.net-fee.action.confirm': '确定',
  'pages.net-fee.action.cancel': '取消',

  // 删除相关
  'pages.net-fee.delete.confirmTitle': '确定要删除这条记录吗？',
  'pages.net-fee.delete.success': '删除成功',
  'pages.net-fee.delete.failure': '删除失败',
  'pages.net-fee.delete.batchDelete.confirmTitle': '确认删除',
  'pages.net-fee.delete.batchDelete.confirmMessage': '确定要删除选中的 {count} 条记录吗？',
  'pages.net-fee.delete.batchDelete.success': '批量删除成功',
  'pages.net-fee.delete.batchDelete.failure': '批量删除失败',
  'pages.net-fee.delete.selectRecordsWarning': '请选择要删除的记录',

  // 审核相关
  'pages.net-fee.audit.selectBillsWarning': '请选择要提交审核的账单',
  'pages.net-fee.audit.modalTitle': '提交审核',
  'pages.net-fee.audit.submitAudit': '提交审核',
  'pages.net-fee.audit.auditName': '审核名称',
  'pages.net-fee.audit.auditNamePlaceholder': '请输入审核名称',
  'pages.net-fee.audit.auditNameRequired': '请输入审核名称',
  'pages.net-fee.audit.submitRemark': '提交说明',
  'pages.net-fee.audit.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.net-fee.audit.selectedBillsTitle': '选中的账单列表（共 {count} 条）',
  'pages.net-fee.audit.success': '提交审核成功',
  'pages.net-fee.audit.failure': '提交审核失败',
  'pages.net-fee.audit.defaultName': '{period} 网费账单 ({count}笔)',
  'pages.net-fee.audit.fetchAuditRecordError': '获取审核记录失败',

  // 详情弹窗
  'pages.net-fee.detail.modalTitle': '网费账单详情',
  'pages.net-fee.detail.close': '关闭',
  'pages.net-fee.detail.basicInfo': '基本信息',
  'pages.net-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.net-fee.detail.amountInfo': '金额信息',
  'pages.net-fee.detail.paymentInfo': '缴费信息',
  'pages.net-fee.detail.systemInfo': '系统信息',
  'pages.net-fee.detail.auditRecord': '审核记录',
  'pages.net-fee.detail.loading': '加载中...',
  'pages.net-fee.detail.noAuditRecord': '暂无审核记录',

  // 详情字段
  'pages.net-fee.detail.billNo': '账单编号',
  'pages.net-fee.detail.period': '账期',
  'pages.net-fee.detail.paymentStatus': '缴费状态',
  'pages.net-fee.detail.approvalStatus': '审核状态',
  'pages.net-fee.detail.startDate': '开始日期',
  'pages.net-fee.detail.endDate': '结束日期',
  'pages.net-fee.detail.houseInfo': '房屋信息',
  'pages.net-fee.detail.ownerInfo': '业主信息',
  'pages.net-fee.detail.ownerIdCard': '身份证',
  'pages.net-fee.detail.ownerEmail': '邮箱',
  'pages.net-fee.detail.ownerId': '业主ID',
  'pages.net-fee.detail.netFeeAmount': '网费金额',
  'pages.net-fee.detail.lateFee': '滞纳金',
  'pages.net-fee.detail.discountAmount': '优惠金额',
  'pages.net-fee.detail.finalAmount': '最终金额',
  'pages.net-fee.detail.paymentMethod': '支付方式',
  'pages.net-fee.detail.paymentReference': '支付凭证号',
  'pages.net-fee.detail.dueDate': '缴费日期',
  'pages.net-fee.detail.paymentDate': '缴费日期',
  'pages.net-fee.detail.createdTime': '创建时间',
  'pages.net-fee.detail.updatedTime': '更新时间',
  'pages.net-fee.detail.remarks': '备注',

  // 状态相关
  'pages.net-fee.status.unpaid': '未缴费',
  'pages.net-fee.status.paid': '已缴费',
  'pages.net-fee.status.overdue': '逾期',
  'pages.net-fee.status.partial': '部分缴费',
  'pages.net-fee.status.cancelled': '已取消',

  // 审核状态
  'pages.net-fee.approvalStatus.draft': '草稿',
  'pages.net-fee.approvalStatus.pending': '待审核',
  'pages.net-fee.approvalStatus.approved': '已通过',
  'pages.net-fee.approvalStatus.rejected': '已拒绝',
  'pages.net-fee.approvalStatus.notified': '已通知',
  'pages.net-fee.approvalStatus.overdue': '逾期',
  'pages.net-fee.approvalStatus.cancelled': '已取消',

  // 表单相关
  'pages.net-fee.form.editTitle': '编辑网费账单',
  'pages.net-fee.form.createTitle': '新建网费账单',
  'pages.net-fee.form.basicInfo': '基本信息',
  'pages.net-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.net-fee.form.feeInfo': '费用信息',
  'pages.net-fee.form.remarksInfo': '备注信息',
  'pages.net-fee.form.update': '更新',
  'pages.net-fee.form.create': '创建',
  'pages.net-fee.form.cancel': '取消',

  // 表单字段
  'pages.net-fee.form.billNo': '账单编号',
  'pages.net-fee.form.billNoPlaceholder': '请输入账单编号',
  'pages.net-fee.form.paymentStatus': '缴费状态',
  'pages.net-fee.form.paymentStatusPlaceholder': '请选择缴费状态',
  'pages.net-fee.form.period': '账期',
  'pages.net-fee.form.periodPlaceholder': '如：2024-01',
  'pages.net-fee.form.periodRequired': '请输入账期',
  'pages.net-fee.form.startDate': '开始时间',
  'pages.net-fee.form.startDatePlaceholder': '请选择开始时间',
  'pages.net-fee.form.startDateRequired': '请选择开始时间',
  'pages.net-fee.form.endDate': '结束时间',
  'pages.net-fee.form.endDatePlaceholder': '请选择结束时间',
  'pages.net-fee.form.endDateRequired': '请选择结束时间',
  'pages.net-fee.form.building': '楼栋',
  'pages.net-fee.form.buildingPlaceholder': '请选择楼栋',
  'pages.net-fee.form.buildingRequired': '请选择楼栋',
  'pages.net-fee.form.floor': '楼层',
  'pages.net-fee.form.floorPlaceholder': '请选择楼层',
  'pages.net-fee.form.floorRequired': '请选择楼层',
  'pages.net-fee.form.house': '房屋',
  'pages.net-fee.form.housePlaceholder': '请选择房屋',
  'pages.net-fee.form.houseRequired': '请选择房屋',
  'pages.net-fee.form.netFeeAmount': '网费金额',
  'pages.net-fee.form.netFeeAmountPlaceholder': '请输入网费金额',
  'pages.net-fee.form.netFeeAmountRequired': '请输入网费金额',
  'pages.net-fee.form.lateFee': '滞纳金',
  'pages.net-fee.form.lateFeePlaceholder': '请输入滞纳金',
  'pages.net-fee.form.discountAmount': '优惠金额',
  'pages.net-fee.form.discountAmountPlaceholder': '请输入优惠金额',
  'pages.net-fee.form.finalAmount': '最终应付金额',
  'pages.net-fee.form.finalAmountPlaceholder': '自动计算',
  'pages.net-fee.form.finalAmountRequired': '最终金额将自动计算',
  'pages.net-fee.form.remarks': '备注',
  'pages.net-fee.form.remarksPlaceholder': '请输入备注信息',
  'pages.net-fee.form.remarksMaxLength': '备注长度不能超过500个字符',

  // 表单验证和错误消息
  'pages.net-fee.form.serviceNotAvailable': '该房屋没有开通此服务，请选择其他房屋',
  'pages.net-fee.form.loadPriceConfigError': '加载网费价格配置失败',
  'pages.net-fee.form.submitSuccess': '创建成功',
  'pages.net-fee.form.updateSuccess': '更新成功',
  'pages.net-fee.form.submitError': '提交失败',

  // 货币单位
  'pages.net-fee.currency.yuan': '₱',
  'pages.net-fee.currency.php': '₱',

  // Detail组件字段
  'pages.net-fee.detail.basicInfo': '基本信息',
  'pages.net-fee.detail.billNo': '账单编号',
  'pages.net-fee.detail.period': '账期',
  'pages.net-fee.detail.paymentStatus': '缴费状态',
  'pages.net-fee.detail.approvalStatus': '审核状态',
  'pages.net-fee.detail.startDate': '开始日期',
  'pages.net-fee.detail.endDate': '结束日期',
  'pages.net-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.net-fee.detail.houseInfo': '房屋信息',
  'pages.net-fee.detail.ownerInfo': '业主信息',
  'pages.net-fee.detail.amountInfo': '金额信息',
  'pages.net-fee.detail.baseAmount': '基础金额',
  'pages.net-fee.detail.lateFee': '滞纳金',
  'pages.net-fee.detail.discountAmount': '优惠金额',
  'pages.net-fee.detail.finalAmount': '最终金额',
  'pages.net-fee.detail.paymentInfo': '缴费信息',
  'pages.net-fee.detail.paymentMethod': '支付方式',
  'pages.net-fee.detail.paymentReference': '支付凭证号',
  'pages.net-fee.detail.dueDate': '到期日期',
  'pages.net-fee.detail.paymentDate': '缴费日期',
  'pages.net-fee.detail.systemInfo': '系统信息',
  'pages.net-fee.detail.createdTime': '创建时间',
  'pages.net-fee.detail.updatedTime': '更新时间',
  'pages.net-fee.detail.remarks': '备注',

  // 分页
  'pages.net-fee.table.pagination.showTotal': '第 {start}-{end} 条/总共 {total} 条',
};
